import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/pages/Index/Index'
import About from '@/components/pages/About/About'
import AbDetail from '@/components/pages/About/AbDetail'
import ContactUs from '@/components/pages/ContactUs/ContactUs'
import NewCenter from '@/components/pages/NewCenter/NewCenter'
import NewDetail from '@/components/pages/NewCenter/NewDetail'
import ProductCenter from '@/components/pages/ProductCenter/ProductCenter'
import ProDetail from '@/components/pages/ProductCenter/ProDetail'
import ProjectCase from '@/components/pages/ProjectCase/ProjectCase'
import ProjectDetail from '@/components/pages/ProjectCase/ProjectDetail'
import ServiceCenter from '@/components/pages/ServiceCenter/ServiceCenter'
import Solution from '@/components/pages/Solution/Solution'
import SoluDetail from '@/components/pages/Solution/SoluDetail'
import DownLoad from '@/components/pages/DownLoad/DownLoad'

/*About组件*/
import Culture from '@/components/pages/About/Acom/Culture'
import Honor from '@/components/pages/About/Acom/Honor'
import Profile from '@/components/pages/About/Acom/Profile'

/*NewCenter组件*/
// import Company from '@/components/pages/NewCenter/Ncom/Company'
// import Trade from '@/components/pages/NewCenter/Ncom/Trade'

/*ProjectCase组件*/
import Goodcase from '@/components/pages/ProjectCase/Pcom/Goodcase'
import Cooperation from '@/components/pages/ProjectCase/Pcom/Cooperation'

/*ServiceCenter组件*/
import Consult from '@/components/pages/ServiceCenter/Scom/Consult'
import Costomer from '@/components/pages/ServiceCenter/Scom/Costomer'
import Repair from '@/components/pages/ServiceCenter/Scom/Repair'

import Loading from '@/components/pages/ServiceCenter/Scom/Loading'

/*ContactUs组件*/
import Contact from '@/components/pages/ContactUs/Ccom/Contact'
import Network from '@/components/pages/ContactUs/Ccom/Network'
import Information from '@/components/pages/ContactUs/Ccom/Information'

///*Loading组件*/
//import Data from '@/components/pages/ServiceCenter/load/Data'
//import Video from '@/components/pages/ServiceCenter/load/Video'
//import Scheme from '@/components/pages/ServiceCenter/load/Scheme'

/*Solution组件*/
import One from '@/components/pages/Solution/Scom/One'
import Two from '@/components/pages/Solution/Scom/Two'
import Three from '@/components/pages/Solution/Scom/Three'
import Four from '@/components/pages/Solution/Scom/Four'
import Five from '@/components/pages/Solution/Scom/Five'

/*ProDetail组件*/
import Describe from '@/components/pages/ProductCenter/PDcom/Describe'
import Parameter from '@/components/pages/ProductCenter/PDcom/Parameter'

//import Six from '@/components/pages/Solution/Scom/Six'

Vue.use(Router)

export default new Router({
  routes: [
  	{
  		path:'/',
  		redirect:'Index'
  	},
  	{
      path: '/Index',
      name: 'Index',
      component: Index,
    },
    {
      path: '/About',
      name: 'About',
      component: About,
      children:[
        {
          path:'/',
          name:'Profile',
          component:Profile
        },
        {
          path:'Profile',
          name:'Profile',
          component:Profile
        },
        {
          path:'Culture',
          name:'Culture',
          component:Culture
        },
         {
          path:'Honor',
          name:'Honor',
          component:Honor
        },
        
      ]
       
    },
    {
    	path:'/AbDetail',
    	name:'AbDetail',
    	component:AbDetail, 
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs,
      children:[
        {
          path:'/',
          name:'Contact',
          component:Contact
        },
        {
          path:'Contact',
          name:'Contact',
          component:Contact
        },
        {
          path:'Network',
          name:'Network',
          component:Network
        },
        {
          path:'Information',
          name:'Information',
          component:Information
        },
        
      ]
      
    },
    {
      path: '/NewCenter',
      name: 'NewCenter',
      component: NewCenter,
    },
    {
      path: '/NewDetail',
      name: 'NewDetail',
      component: NewDetail
    },
    {
      path: '/ProductCenter',
      name: 'ProductCenter',
      component: ProductCenter
    },
    {
      path: '/ProDetail',
      name: 'ProDetail',
      component: ProDetail,
    },
    {
      path: '/ProjectCase',
      name: 'ProjectCase',
      component: ProjectCase,
      children:[
        {
          path:'/',
          name:'Goodcase',
          component:Goodcase
        },
        {
          path:'Goodcase',
          name:'Goodcase',
          component:Goodcase
        },
        {
          path:'Cooperation',
          name:'Cooperation',
          component:Cooperation
        },
         
        
      ]
    },
    {
      path:'/ProjectDetail',
      name:'ProjectDetail',
      component:ProjectDetail,
       
    },
    {
      path: '/ServiceCenter',
      name: 'ServiceCenter',
      component: ServiceCenter,
      children:[
        {
          path:'/',
          name:'Consult',
          component:Consult
        },
        {
          path:'Consult',
          name:'Consult',
          component:Consult
        },
        {
          path:'Costomer',
          name:'Costomer',
          component:Costomer
        },
        {
          path:'Repair',
          name:'Repair',
          component:Repair
        },
        
      ]
      
    },
    {
      path: '/Solution',
      name: 'Solution',
      component: Solution,
      children:[
	      	{
	      		path:'/',
	      		name:'One',
	      		component:One
	      	},
	      	{
	      		path:'One',
	      		name:'One',
	      		component:One
	      	},
	      	{
	      		path:'Two',
	      		name:'Two',
	      		component:Two
	      	},
	      	{
	      		path:'Three',
	      		name:'Three',
	      		component:Three
	      	},
	      	{
	      		path:'Four',
	      		name:'Four',
	      		component:Four
	      	},
	      	{
	      		path:'Five',
	      		name:'Five',
	      		component:Five
	      	},
	      	
      ]
    },
    {
    	path:'/SoluDetail',
    	name:'SoluDetail',
    	component:SoluDetail,
    	 
    },
    {
      path:'/DownLoad',
      name:'DownLoad',
      component:DownLoad,
       
    }
//  {
//        path:'/Loading',
//        name:'Loading',
//        component:Loading,
//        children:[
//			        {
//			          path:'/',
//			          name:'Data',
//			          component:Data
//			        },
//			        {
//			          path:'Data',
//			          name:'Data',
//			          component:Data
//			        },
//			        {
//			          path:'Video',
//			          name:'Video',
//			          component:Video
//			        },
//			        {
//			          path:'Scheme',
//			          name:'Scheme',
//			          component:Scheme
//			        },
//
//    		]
//      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js